module.exports = __webpack_public_path__ + "static/media/cart.bb0ac947.png";